


































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AutoPlay, Pagination } from "@egjs/flicking-plugins";
import { authModule, metamaskModule, stakingModule } from "@/store";
import Card from "@/components/ui/card/Card.vue";
import Loader from "@/components/ui/Loader.vue";
import StakingEmpty from "@/components/staking/StakingEmpty.vue";
import { Campaign } from "@/store/staking/campaign";
import { AuthStatus } from "@/store/auth/auth-status.enum";
import { Stake } from "@/store/staking/stake";

class CampaignSummary {
  constructor(public readonly campaign: Campaign) {}
  deposit = 0;
  rewards = 0;
  nextRelease?: Date;
}

@Component({
  components: { StakingEmpty, Loader, Card },
})
export default class DashboardStaking extends Vue {
  autoplay = new AutoPlay({ duration: 4000, stopOnHover: true });
  pagination = new Pagination({ type: "bullet" });
  flicking = {
    options: {
      align: "prev",
      circular: true,
      noPanelStyleOverride: true,
    },
    plugins: [this.autoplay, this.pagination],
  };

  summaryMap = new Map<string, CampaignSummary>();

  get loading(): boolean {
    return stakingModule.isLoadingCampaigns || stakingModule.isLoadingStakes;
  }

  get summaries(): CampaignSummary[] {
    return Array.from(this.summaryMap.values());
  }

  get account(): string {
    return metamaskModule.account;
  }

  get authStatus(): AuthStatus {
    return authModule.authStatus;
  }

  get isGoodNetwork(): boolean {
    return metamaskModule.isGoodNetwork;
  }

  get stakes(): Stake[] {
    return stakingModule.stakes;
  }

  async fetch(): Promise<void> {
    await stakingModule.fetch();
    await stakingModule.fetchStakes(this.account);
  }

  async build(): Promise<void> {
    this.summaryMap = new Map<string, CampaignSummary>();
    for (const stake of this.stakes) {
      let summary;
      if (!this.summaryMap.has(stake.campaign.address)) {
        summary = new CampaignSummary(stake.campaign);
      } else {
        summary = this.summaryMap.get(
          stake.campaign.address
        ) as CampaignSummary;
      }

      summary.deposit += +stake.amount;
      summary.rewards += +stake.rewards;
      if (!summary.nextRelease || summary.nextRelease > stake.endsOn) {
        summary.nextRelease = stake.endsOn;
      }

      this.summaryMap.set(stake.campaign.address, summary);
    }
  }

  @Watch("account", { immediate: true })
  @Watch("authStatus")
  @Watch("isGoodNetwork")
  async refresh(): Promise<void> {
    await this.fetch();
  }

  @Watch("stakes")
  async onStakesChanged(): Promise<void> {
    await this.build();
  }
}
